import { Link } from "react-router-dom";

export default function Footer({ content, scrollTo }) {
  return (
    <footer className="bg-[#1a1a1a] text-[#f9f6f0] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-white/10">
          <div>
            <img src={content.logo} alt={content.brand_name} className="h-16 w-auto object-contain" />
            <p className="mt-5 text-white/60 max-w-xs leading-relaxed">{content.hero_subtitle}</p>
          </div>
          <div>
            <h4 className="font-display text-xl mb-4">Navegación</h4>
            <ul className="space-y-2.5 text-white/60">
              {["historia", "platos", "galeria", "menu", "resenas", "eventos", "reservar", "contacto"].map((id) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="hover:text-white capitalize transition-colors">
                    {id === "menu" ? "Menú" : id === "resenas" ? "Reseñas" : id === "galeria" ? "Galería" : id}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-xl mb-4">Contacto</h4>
            <ul className="space-y-2.5 text-white/60">
              <li>{content.address}</li>
              <li>
                <a href={`tel:${content.phone.replace(/[^+\d]/g, "")}`} className="hover:text-white transition-colors">{content.phone}</a>
              </li>
              <li>{content.hours}</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/40">
          <p>© {new Date().getFullYear()} {content.brand_name}. Todos los derechos reservados.</p>
          <Link to="/admin/login" data-testid="admin-access-link" className="hover:text-white transition-colors">
            Acceso administrador
          </Link>
        </div>
      </div>
    </footer>
  );
}
